import { render } from "./ReferenceItemsPage.vue?vue&type=template&id=07d5e2b6&scoped=true"
import script from "./ReferenceItemsPage.vue?vue&type=script&lang=js"
export * from "./ReferenceItemsPage.vue?vue&type=script&lang=js"

import "./ReferenceItemsPage.vue?vue&type=style&index=0&id=07d5e2b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d5e2b6"]])

export default __exports__